module.exports = __webpack_public_path__ + "static/media/mwsg__.ef862446.svg";